<!-- 選擇區塊 -->
<ng-template #Modal let-data let-ref="dialogRef">
    <nb-card class="staffInfoTemplate">
      <nb-card-header>
        媒體申報檔對帳
      </nb-card-header>

      <nb-card-body>
        <div class="row">
          <div class="row mx-0 col-sm-12 mt-2">
            <label class="label col-sm-12 col-form-label">選擇對帳年份</label>
            <nb-select placeholder="請選擇" name="YearList" fullWidth [(ngModel)]="year">
              <nb-option *ngFor="let e of YearList"
                [value]="e.value">{{e.content}}</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row">
          <div class="row mx-0 col-sm-12 mt-2">
            <label class="label col-sm-12 col-form-label">選擇對帳月數</label>
            <nb-select placeholder="請選擇" name="MonthList" fullWidth [(ngModel)]="month">
              <nb-option *ngFor="let e of MonthList"
                [value]="e.value">{{e.content}}</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row">
          <div class="row mx-0 col-sm-12 mt-2">
            <label class="label col-sm-12 col-form-label">上傳媒體申報檔</label>
            <input type="file" 
                  #fileInput
                  (change)="onFileSelected($event)" 
                  accept=".csv" 
                  style="display:none">
            <button (click)="fileInput.click()" class="file-upload-label" nbButton>
              {{ fileName || '選擇 CSV 檔案' }}
            </button>
          </div>
        </div>

      </nb-card-body>

      <nb-card-footer>
        <button nbButton (click)="onUpdate();" [disabled]="!selectedFile">對帳</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>

    </nb-card>

  </ng-template>